"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nextTick = nextTick;

// Copyright 2017-2022 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * @name nextTick
 * @description Defer the operation to the queue for evaluation on the next tick
 */
function nextTick(onExec, onError) {
  Promise.resolve().then(() => {
    onExec();
  }).catch(error => {
    if (onError) {
      onError(error);
    } else {
      console.error(error);
    }
  });
}